import React, { useEffect, useState, useContext } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, LabelList, Text, ResponsiveContainer } from 'recharts'
import { MyContext } from './MyContext';
import * as downtimeUtils from './DowntimeUtils';
import useDisplayConfig from './useDisplayConfig';

export const colors = [
    "#3366CC99",
    "#DC391299",
    "#FF990099",
    "#10961899",
    "#99009999",
    "#3B3EAC99",
    "#0099C699",
    "#DD447799",
    "#66AA0099",
    "#B82E2E99",
    "#31639599",
    "#99449999",
    "#22AA9999",
    "#AAAA1199",
    "#6633CC99",
    "#E6730099",
    "#8B070799",
    "#32926299",
    "#5574A699",
    "#3B3EAC99"
];

const DownTimeTotals = ({displayConfigId=null}) => {
    const { data, dialogReasonCodes, persistedDowntimeReasonCodes, dowtimeTotals, setDowntimeTotals, selectedMachines, totalUnlabeledDowntime } = useContext(MyContext);


    useEffect(() => {

        if (persistedDowntimeReasonCodes) {
            var downtimeReasonCodes = downtimeUtils.initDownTimeReasons(persistedDowntimeReasonCodes, selectedMachines);
            var sdowntimeTotals = downtimeUtils.createDownTimeTotals(dialogReasonCodes, downtimeReasonCodes);
            if (sdowntimeTotals) {
                //convert these to hours
                sdowntimeTotals.forEach(a => {
                    a.duration /= 60;
                    a.duration = Math.round(a.duration * 10) / 10;
                })
            }
            setDowntimeTotals(sdowntimeTotals);
        }

    }, [persistedDowntimeReasonCodes, selectedMachines])

    useDisplayConfig({displayName:displayConfigId});
    return (
        <div>
            <div style={{ display: 'flex' }}>
            <div style={{ marginTop: '2px' }}>
                <h4>Total Unlabeled Downtime: {totalUnlabeledDowntime ?  totalUnlabeledDowntime<100 ? totalUnlabeledDowntime + ' mins' : Math.trunc(totalUnlabeledDowntime*100/60)/100 + ' hrs' : 0}</h4>
            </div>
            </div>
            <div>
                <ResponsiveContainer width={"100%"} height={300} >
                    <BarChart data={dowtimeTotals}
                        margin={{ top: 5, right: 30, left: 20, bottom: 5 }} >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis label={
                            <Text x={0} y={0} dx={25} dy={300} offset={0} angle={-90} >Machine Down Time - hrs</Text>
                        } />
                        <Tooltip />

                        <Bar dataKey="duration" isAnimationActive={false}>
                            <LabelList dataKey="duration" position="middle" fill="white" />
                            {
                                dowtimeTotals?.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={colors[index]} />
                                ))
                            }

                        </Bar>

                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>

    );
};

export default DownTimeTotals;
